export enum ProductSelectorType {
    Product = 'Product',
    ProductBundle = 'ProductBundle',
    ProductGroup = 'ProductGroup',
}
